import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { StateManager } from '../utilities/stateManager';
import { getCheckPdfUrl } from '../utilities/requestManager';

// Admin-only trigger to write a check for one or more purchase/expense objects.
// Drop this anywhere a purchase is interfaced. Self-hides for non-admins.
//   <WriteCheckButton purchases={payable} />
//   <WriteCheckButton purchases={selectedRows} label="Write Checks" />
export function WriteCheckButton({ purchases, label, iconOnly = false, size = 'small', ...props }) {
  if (!StateManager.isAdmin()) return null;

  const list = (Array.isArray(purchases) ? purchases : [purchases]).filter(Boolean);
  const disabled = list.length === 0;

  const open = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    StateManager.openWriteCheckModal(list);
  };

  if (iconOnly) {
    return (
      <Tooltip title={label || 'Write check'}>
        <span>
          <IconButton size={size} color="primary" onClick={open} disabled={disabled} {...props}>
            <PaymentsIcon fontSize="inherit" />
          </IconButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      size={size} variant="outlined" startIcon={<PaymentsIcon />}
      onClick={open} disabled={disabled} {...props}
    >
      {label || 'Write Check'}
    </Button>
  );
}

// Re-open / re-print the PDF for a purchase that already has a check.
// Renders nothing unless the purchase has been checked (checkId/checkNumber).
//   <ViewCheckButton purchase={payable} />
export function ViewCheckButton({ purchase, iconOnly = true, size = 'small', ...props }) {
  const checkId = purchase && (purchase.checkId || purchase.checkNumber);
  if (!checkId) return null;

  const view = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    window.open(getCheckPdfUrl(checkId), '_blank');
  };

  if (iconOnly) {
    return (
      <Tooltip title={`View check ${checkId}`}>
        <IconButton size={size} onClick={view} {...props}>
          <ReceiptLongIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button size={size} variant="text" startIcon={<ReceiptLongIcon />} onClick={view} {...props}>
      View Check
    </Button>
  );
}

export default WriteCheckButton;
